import { useTranslation } from '../../i18n/useTranslation';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Portal from '@mui/material/Portal';
import Snackbar from '@mui/material/Snackbar';
import { useNavigate } from 'react-router-dom';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { shopingCartAlertMaxWidth } from '../shopping-cart/services/shopping-cart.service';
import { SHOPPING_CART_PATHS } from '../../shared/constants/breadcrumb.constants';
import { useEffect, useRef } from 'react';
import variables from './FixcenterOrderingTable.module.scss';

interface IShopingCartAlertProp {
    isOpen: boolean;
    handleCloseDialog: Function;
    autoHideDurationInMs: number;
}

const ShopingCartAlert: React.FC<IShopingCartAlertProp> = ({ isOpen, handleCloseDialog, autoHideDurationInMs }) => {
    const { t } = useTranslation('translation');
    const navigate = useNavigate();
    const closeRef = useRef(handleCloseDialog);
    closeRef.current = handleCloseDialog;

    // Hides after a fixed delay, regardless of hover or window focus (Snackbar's autoHideDuration pauses on both).
    useEffect(() => {
        if (!isOpen) {
            return;
        }
        const timer = setTimeout(() => closeRef.current(false), autoHideDurationInMs);
        return () => clearTimeout(timer);
    }, [isOpen, autoHideDurationInMs]);

    // Rendered in a portal, outside the table DOM, so the `.table_container button` rules do not apply to it.
    return (
        <Portal>
            <Snackbar
                open={isOpen}
                onClose={() => handleCloseDialog(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Paper
                    elevation={24}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        px: 3,
                        py: 2.5,
                        maxWidth: shopingCartAlertMaxWidth,
                    }}
                >
                    <Box sx={{ minWidth: 50, display: 'flex', alignItems: 'center' }}>
                        <ShoppingCartIcon sx={{ fontSize: 30 }} />
                    </Box>
                    <section>
                        <label>{t('FIXCENTER_ORDERING.HEADER_1')}</label>
                        <Button
                            id={'shopping-cart-alert-go-to-cart-btn'}
                            variant="contained"
                            fullWidth
                            disableElevation
                            sx={{
                                mt: 1.5,
                                height: 30,
                                minHeight: 30,
                                py: 0,
                                textTransform: 'none',
                                borderRadius: 0,
                                fontWeight: 'bold',
                                fontSize: 15,
                                color: variables.whiteColor,
                                bgcolor: variables.appRedColor,
                                '&:hover': { bgcolor: variables.appRedColor },
                            }}
                            onClick={() => {
                                navigate(SHOPPING_CART_PATHS[1].link);
                            }}
                        >
                            {t('GO_TO_CART')}
                        </Button>
                    </section>
                </Paper>
            </Snackbar>
        </Portal>
    );
};
export default ShopingCartAlert;
